import type { Provider } from '@angular/core';
import {
  MAT_DATE_LOCALE,
  MAT_RIPPLE_GLOBAL_OPTIONS,
  type RippleGlobalOptions,
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { es } from 'date-fns/locale';
import { CustomMatPaginatorIntl } from './custom-paginator-intl';

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 0,
    exitDuration: 0,
  },
};

export const materialProviders: Provider[] = [
  { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      appearance: 'outline',
      subscriptSizing: 'dynamic',
      floatLabel: 'always',
    },
  },
  { provide: MAT_DATE_LOCALE, useValue: es },
  provideDateFnsAdapter(),
];
